import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);

export const isNew = ({ week, year, create_timestamp }) => {
    const prevWeek = dayjs().week(week).year(year).subtract(1, 'week');
    const prevWeekTimeStamp = prevWeek.unix();
    return create_timestamp > prevWeekTimeStamp;
};
